// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".StoreItems-Item{display:block;width:50px;line-height:50px;text-align:center;border-right:1px solid #D9D9D9;font-size:var(--font-size)}@media (min-width: 361px){.StoreItems-Item{width:60px;line-height:60px}}.StoreItems-Item:hover{color:var(--color-brand)}\n", ""]);
// Exports
module.exports = exports;
